import { BREATHE_CLASS } from "@neucleos/motion-primitives";

import { cn } from "~/lib/utils";
import {
  ROOT_SESSION_STATUS_LABELS,
  rootSessionStatusTextClass,
  type RootSessionStatus,
} from "~/rootSessionStrip";
import "./RoomStatusIndicator.css";

/** The Room status is display-only; a quiet Room has no status mark. */
export function RoomStatusIndicator({ status }: { readonly status: RootSessionStatus | null }) {
  if (status === null) return null;
  return (
    <span
      aria-hidden="true"
      className={cn(
        "ncl-room-status",
        rootSessionStatusTextClass(status),
        status === "working" && BREATHE_CLASS,
      )}
      data-room-status={status}
    >
      {status === "failed" ? "!" : null}
    </span>
  );
}

/** Count the complete Room membership once per status, using the shared vocabulary. */
export function roomStatusDescription(
  label: string,
  statuses: ReadonlyArray<RootSessionStatus | null>,
): string {
  const counts = new Map<RootSessionStatus | null, number>();
  for (const status of statuses) counts.set(status, (counts.get(status) ?? 0) + 1);
  const order: ReadonlyArray<RootSessionStatus | null> = [
    "failed",
    "approval",
    "input",
    "working",
    "monitoring",
    "done",
    null,
  ];
  const breakdown = order.flatMap((status) => {
    const count = counts.get(status);
    return count === undefined
      ? []
      : [`${count} ${status === null ? "Quiet" : ROOT_SESSION_STATUS_LABELS[status]}`];
  });
  return `${label} · ${statuses.length} ${statuses.length === 1 ? "session" : "sessions"}${breakdown.length ? ` · ${breakdown.join(" · ")}` : " · Quiet"}`;
}
